class Controller {
  constructor($mdDialog, $state, $injector, admin, reUpdateAdminsEvent) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.Events = $injector.get("Events");
    this.Corporate = $injector.get("Corporate");
    this.admin = admin;
    this.reUpdateAdminsEvent = reUpdateAdminsEvent;
    this.successEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.adminLookerRoles = {};
    if (this.admin.looker_roles) {
      const {
        group_ids: groupIds,
        custom_1: custom1,
        custom_2: custom2,
      } = this.admin.looker_roles;

      this.adminLookerRoles = {
        looker_group_ids: groupIds ? groupIds.join(",") : undefined,
        looker_custom_1: custom1,
        looker_custom_2: custom2,
      };
    }
  }

  editAdminLookerRoles() {
    const editedRoles = {
      looker_group_ids: this.adminLookerRoles.looker_group_ids
        ? this.adminLookerRoles.looker_group_ids
            .split(",")
            .map((num) => parseInt(num, 10))
        : undefined,
      looker_custom_1: this.adminLookerRoles.looker_custom_1 || undefined,
      looker_custom_2: this.adminLookerRoles.looker_custom_2 || undefined,
    };
    this.Corporate.updateAdminLookerRoles({
      _id: this.admin._id,
      ...editedRoles,
    }).$promise.then(
      () => {
        this.Events.emit(this.successEvent, {
          message: "Looker roles updated successfully",
        });
        // Refresh admins list
        this.Events.emit(this.reUpdateAdminsEvent);
        this.$mdDialog.hide();
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.editAdminLookerRoles();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/editAdminLookerDialog/editAdminLookerDialog.controller.js